<template>
  <label class="check-box" :class="{ on: modelValue, disable }" @click.prevent="onClick">
    <span class="box"></span>
    <span v-if="label" class="label">{{ label }}</span>
  </label>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label?: string
    modelValue: boolean
    disable?: boolean
  }>(),
  {
    label: '',
    disable: false,
  },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const onClick = () => {
  if (!props.disable) emit('update:modelValue', !props.modelValue)
}
</script>

<style>
.check-box {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  min-height: 24px;
  user-select: none;
}
.check-box .box {
  width: 20px;
  height: 20px;
  border: 1.5px solid var(--asf-check-border, #c1c8cf);
  border-radius: 4px;
  display: inline-flex;
  flex-shrink: 0;
  background: white;
  position: relative;
  box-sizing: border-box;
}
.check-box.on .box {
  background: var(--asf-check-accent, #145ce6);
  border-color: var(--asf-check-accent, #145ce6);
}
.check-box.on .box::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 6px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.check-box.disable {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
